import axios from '@/utils/axios'
// 组件列表
export function list(query) {
    return axios({
        url: '/video/rechargeTemplate/list',
        method: 'get',
        params: query
    })
}

//配置方案组件列表
export function waylist(query) {
    return axios({
        url: '/video/rechargeTemplate/plan/list',
        method: 'get',
        params: query
    })
}

// 添加
export function add(query) {
    return axios({
        url: '/video/rechargeTemplate/addOrUpdTemplate/save',
        method: 'post',
        params: query
    })
}
// 删除
export function del(query) {
    return axios({
        url: '/video/rechargeTemplate/delTemplate/save',
        method: 'post',
        params: query
    })
}
// 详情
export function details(query) {
    return axios({
        url: '/video/rechargeTemplate/addOrUpdTemplate',
        method: 'get',
        params: query
    })
}
// 充值方案配置详情
export function wayDetails(query) {
    return axios({
        url: '/video/rechargeTemplate/getRechargePlanConfigInfo',
        method: 'get',
        params: query
    })
}

// 充值方案-添加
export function wayAdd(query) {
    return axios({
        url: '/video/rechargeTemplate/addOrEditRechargePlanInfo/save',
        method: 'post',
        params: query
    })
}

// 充值方案配置-添加档位
export function listWayAdd(query) {
    return axios({
        url: '/video/rechargeTemplate/addPlanTemplateData/save',
        method: 'post',
        params: query
    })
}
// 删除已配置的档位
export function delWay(query) {
    return axios({
        url: '/video/rechargeTemplate/delConfigTemplate/save',
        method: 'post',
        params: query
    })
}

//方案档位排序
export function planOrder(query) {
    return axios({
        url: '/video/rechargeTemplate/planData/order',
        method: 'post',
        params: query
    })
}